<div
  class="ui basic segment conversation"
  style="border: none"
  #scrollContainer
>
  <div
    class="chat-history ui basic segment"
    [ngClass]="{ loading: isHistoryPending }"
  >
    <div class="controls">
      <div class="ui input">
        <!-- <input
          type="text"
          placeholder="Search chat sessions"
          [(ngModel)]="searchQuery"
          (input)="filterChatSessions()"
        /> -->
      </div>
      <div class="right">
        <!-- <img class="search-icon" src="assets/icons/search.svg" /> -->
        <button class="edit-icon">
          <img src="assets/icons/edit.svg" (click)="NewChat()" />
        </button>
      </div>
    </div>
    <div *ngFor="let history_item of filteredHistory">
      <h2>{{ history_item.date_category }}</h2>
      <ul>
        <li
          *ngFor="let item of history_item.items"
          (click)="setSessionID(item.session_id)"
          [ngClass]="{ active: item.session_id === sessionId }"
        >
          {{ item.subject || "No Subject" }}
        </li>
      </ul>
      <esl-empty
      *ngIf="!filteredHistory.length"
        [title]="'No items yet'"
        imgType="illustration"
      ></esl-empty>
    </div>
  </div>
  <div class="left-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="!messages.length" class="chat-start-container">
      <div class="container">
        <h1 class="title">What can I help with?</h1>
        <form [formGroup]="replyForm" (ngSubmit)="ngSubmit()" class="chat-box">
          <input
            type="text"
            name="comment"
            formControlName="comment"
            placeholder="Message NCC AI Chatbot"
            class="chat-input"
          />
          <button
            [disabled]="(createPending$ | async) || !(canReply$ | async)"
            class="send-button"
            type="submit"
          >
            ↩
          </button>
        </form>
      </div>
    </div>

    <div *ngIf="messages.length" class="chats">
      <app-ai-chat-messages
        [messages]="messages"
        (message)="updateMessage($event)"
      ></app-ai-chat-messages>

      <form [formGroup]="replyForm" (ngSubmit)="ngSubmit()" class="chat-box">
        <input
          type="text"
          name="comment"
          formControlName="comment"
          placeholder="Message NCC AI Chatbot"
          [disabled]="(createPending$ | async) || !(canReply$ | async)"
          class="chat-input"
        />
        <button
          [disabled]="(createPending$ | async) || !(canReply$ | async)"
          class="send-button"
          type="submit"
        >
          ↩
        </button>
      </form>
    </div>
  </div>
</div>
